// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import global_ from "./Global";

Vue.config.productionTip = false;

//配置ElementUI前端快速开发框架
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
Vue.use(ElementUI);
//配置全局变量
Vue.prototype.GLOBALS = global_; //全局变量对象
//loading
Vue.prototype.load = new Vue();
//网络请求
import * as requestApi from "./utils/api";
console.log(requestApi);
Vue.use(requestApi);

//视频播放
import { videoPlayer } from "vue-video-player";
import "video.js/dist/video-js.css";
import "vue-video-player/src/custom-theme.css";

import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

//import './style/siyuan.less';

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  components: { App },
  template: "<App/>",
});



// WEBPACK FOOTER //
// ./src/main.js